module.exports = __webpack_public_path__ + "checker_black.5dbb064.png";